import { useEffect } from 'react';
import constants from '../../constants';
import LoadingScreen from '../LoadingScreen';

const LoginRedirect = () => {
  useEffect(() => {
    window.location.href = `${constants.LOGIN_URL}/register`;
  }, []);

  return <LoadingScreen />;
};

export default LoginRedirect;
